import React, { useEffect } from "react";
import useTheme from "../../hooks/useTheme";
import loanlogs from "../../services/loanlogs";

function NotMobile() {    
    const theme = useTheme()
    
    useEffect(() => {
        loanlogs.success('/not-mobile').catch(console.log)
    }, []);
    
    return (
        <div className="page-error">
            <header className="page-error-header">
                <img src={`/${theme}/logo-dark.png`} width="200" alt="" />
            </header>
            <main className="page-error-content place-self-center stack text-center">
                <h1 className="text-center text-3xl">¡No es posible abrir este enlace!</h1>
                <p className="text-center text-xl">
                    Necesitamos que accedas desde tu celular 
                    para poder continuar con la operación.
                </p>
                <img className="center" src={`/${theme}/phone.svg`} alt="" />
            </main>
        </div>
    )
}

export default NotMobile;
